import { LOGOUT } from 'actions/action_types';

export function logoutAction() {
  return {
    type: LOGOUT,
  };
}
